import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
} from '@angular/core';

@Component({
  selector: 'cp-callback',
  template: '<ui-progress-spinner></ui-progress-spinner>',
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
// Empty component to fix infinite redirect issue.
// https://github.com/auth0/auth0-angular/blob/master/FAQ.md#4-getting-an-infinite-redirect-loop-between-my-application-and-auth0
export class CallbackComponent {}
